import Typography from '@material-ui/core/Typography';
import { baseStyles } from '../../../theme/base.styles';

export default function ChatIcon() {
    const baseClasses = baseStyles();

    return (
        <Typography component={'div'} className={`${baseClasses.spacingNormal} ${baseClasses.chatIcon}`}>
            <flos-icon shape="avatar-colored" size="40" />
        </Typography>
    );
}
